import { app } from '../../../../../app';
import { Controller } from './supported-epm-types.controller';

app.component('companySupportedEpmTypes', {
    bindings: {
        publicServicesWithEPM$: '<',
    },
    controller: Controller,
    templateUrl: require('./supported-epm-types.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-epm-types/list/supported-epm-types.component.js